import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../../service/ApiService";
import { apiPaths } from "../../service/apiPaths";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { initializeCart, toggleAuthentication } from "../../redux/hejalSlice";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading,setLoading]=useState(false)
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handleSendOtp = async (e) => {
    setLoading(true)
    e.preventDefault();
    // Basic validation
    if (!email) {
      setErrEmail("Enter your email");
      return;
    }

    try {
      // API call for sending OTP
      const response = await ApiService({
        method: "POST",
        endpoint: apiPaths.ForgotPassword,
        data: { email },
      });

      console.log(response);
      // dispatch(toggleAuthentication());
      // if (response.user?.cart) {
      //   dispatch(initializeCart(response.user?.cart));
      // }


      // console.log("Response from API:", response);

      if (response.errorCode) {
        // Handle errors like incorrect login
        toast.error(response.message || "Failed to send OTP, try again!");
        setErrEmail("Invalid email or account not found");
      } else {
        setSuccessMsg("OTP sent successfully! || redirecting...");

        // Get the algorithm name from the response
        const algoName = response.data?.algoName;

        navigate(`/verifyotp`, {
          state: {
            email: email,
            algoName: algoName,
          },
        });
      }
    } catch (error) {
      // Handle unexpected errors
      console.error("Failed to send OTP:", error);
      toast.error(error?.response?.data?.message || "Server error.");
    }finally{
      setLoading(false)
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-start">
      <div className=" h-full w-full">
        <div className="">
          <div className="w-full bg-[#efefef] h-full">
            {successMsg ? (
              <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
                <p className="w-full px-4 py-10 text-green-500 font-medium font-titleFont">
                  {successMsg}
                </p>
                <Link to="/signup">
                  <button className="w-full h-10 bg-primeColor text-gray-200 rounded-md text-base font-titleFont font-semibold tracking-wide hover:bg-black hover:text-white duration-300">
                    Sign Up
                  </button>
                </Link>
              </div>
            ) : (
              <form
                className="w-full h-screen flex items-center justify-center"
              >
                <div className="px-6 max-w-[500px] min-h-[350px] bg-[#fff] py-10 w-full flex flex-col  overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
                  <h1 className="font-titleFont decoration-[1px] font-semibold text-[20px] mdl:text-[24px] mb-4">
                    Forgot Your Password
                  </h1>
                  <div className="flex flex-col justify-between gap-3 h-full flex-1">
                    <div className="flex flex-col gap-.5">
                      <p className="font-medium text-[14px]">Email</p>
                      <input
                        onChange={handleEmail}
                        value={email}
                        className="w-full lg:h-12 bg-transparent mb-4 h-8 placeholder:text-sm placeholder:tracking-wide px-4 text-base font-medium placeholder:font-normal border-b-[1px] border-gray-400 outline-none"
                        type="email"
                        placeholder="john@workemail.com"
                        required
                      />
                      {errEmail && (
                        <p className="text-sm text-red-500 font-titleFont font-semibold px-4">
                          <span className="font-bold italic mr-1">!</span>
                          {errEmail}
                        </p>
                      )}
                    </div>
                    <div>
                      {/* <button
                        type="submit"
                        className="mix-bg hover:bg-black text-gray-200 hover:text-white cursor-pointer w-full text-base font-medium h-10 rounded-md duration-300"
                      >
                        Send OTP
                      </button> */}
                      <button
                      onClick={handleSendOtp}
                      disabled={loading}
                      className={`bg-secondColor hover:bg-black text-black-200 hover:text-white cursor-pointer w-full text-base font-medium h-10 rounded-md duration-300 flex items-center justify-center ${loading ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                    >
                      {loading ? (
                        <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-solid border-current border-r-transparent align-middle motion-reduce:animate-[spin_1.5s_linear_infinite]"></span>
                      ) : (
                        "Send OTP"
                      )}
                    </button>
                      <p className="text-sm text-center font-titleFont font-medium mt-4">
                        Don't have an Account?{" "}
                        <Link to="/signup">
                          <span className="hover:text-blue-600 duration-300">
                            Sign up
                          </span>
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
